import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SavesProvider } from "@/contexts/SavesContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Categories from "@/pages/Categories";
import Search from "@/pages/Search";
import VenueDetail from "@/pages/VenueDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Nominate from "@/pages/Nominate";
import Dashboard from "@/pages/Dashboard";
import InspectionForm from "@/pages/InspectionForm";
import SavedPlaces from "@/pages/SavedPlaces";
import MyClaims from "@/pages/MyClaims";
import AdminTemplates from "@/pages/AdminTemplates";
import AdminClaims from "@/pages/AdminClaims";
import AdminAreas from "@/pages/AdminAreas";
import AreaLanding from "@/pages/AreaLanding";
import Trips from "@/pages/Trips";
import TripDetail from "@/pages/TripDetail";
import PublicTrip from "@/pages/PublicTrip";
import Coverage from "@/pages/Coverage";
import Nominator from "@/pages/Nominator";
import Forgot from "@/pages/Forgot";
import Reset from "@/pages/Reset";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SavesProvider>
            <Toaster position="top-center" richColors closeButton />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/search" element={<Search />} />
                <Route path="/venue/:id" element={<VenueDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot" element={<Forgot />} />
                <Route path="/reset" element={<Reset />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/nominate" element={
                  <ProtectedRoute roles={["member", "admin", "inspector"]}><Nominate /></ProtectedRoute>
                } />
                <Route path="/dashboard" element={
                  <ProtectedRoute><Dashboard /></ProtectedRoute>
                } />
                <Route path="/saved" element={
                  <ProtectedRoute><SavedPlaces /></ProtectedRoute>
                } />
                <Route path="/trips" element={
                  <ProtectedRoute><Trips /></ProtectedRoute>
                } />
                <Route path="/trips/:id" element={
                  <ProtectedRoute><TripDetail /></ProtectedRoute>
                } />
                <Route path="/trip/:slug" element={<PublicTrip />} />
                <Route path="/area/:name" element={<AreaLanding />} />
                <Route path="/coverage" element={<Coverage />} />
                <Route path="/nominator/:id" element={<Nominator />} />
                <Route path="/claims" element={
                  <ProtectedRoute><MyClaims /></ProtectedRoute>
                } />
                <Route path="/inspection/:id" element={
                  <ProtectedRoute roles={["inspector", "admin"]}><InspectionForm /></ProtectedRoute>
                } />
                <Route path="/admin/templates" element={
                  <ProtectedRoute roles={["admin"]}><AdminTemplates /></ProtectedRoute>
                } />
                <Route path="/admin/claims" element={
                  <ProtectedRoute roles={["admin"]}><AdminClaims /></ProtectedRoute>
                } />
                <Route path="/admin/areas" element={
                  <ProtectedRoute roles={["admin"]}><AdminAreas /></ProtectedRoute>
                } />
              </Routes>
            </Layout>
          </SavesProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
